import { createSelector } from 'reselect';
import studentModuleSelector from './studentModule';

export default createSelector(studentModuleSelector, (module) => module && module.name);
